export default __webpack_public_path__ + "static/media/risk.927bdf09.svg";